module.exports = __webpack_public_path__ + "img/obifi-blue.3aa7b123.svg";